import { authHeader } from '../../_helpers';
import axios from 'axios';

export const collaborationSevice = {
    getCollaborationData,
}

axios.defaults.headers.common = authHeader();
let token = localStorage.getItem('access_token')


function getCollaborationData(data) {
    return axios.post(`/analytics/analytics_organisation/team/analyse/collabaration/?access_token=${token}`,data)
        .then(response => {
            return response;
        });
}


// WEBPACK FOOTER //
// ./src/_services/Analyze/collaboration.service.js